<template>
  <el-popover
    :placement="placement"
    :width="width"
    :trigger="trigger"
    :popper-class="popperClass">
    <div class="prompt-content">
      <slot></slot>
    </div>
      <div slot="reference" class="icon_box">
        <img src="https://cdn-image.yucrm.cn/images/tb-front-platform/images/potentialmemberanalysis/title-icon.png" v-if="isWhite"
          style="width: 14px; height: 14px; margin-bottom: -3px;" :style="{ marginLeft: iconleft }" />
        <img src="@/assets/homeDemo/question.png" v-else
          style="width: 14px; height: 14px; margin-bottom: -3px;" :style="{ marginLeft: iconleft }" />
      </div>
  </el-popover>
</template>

<script>
export default {
  name: "PromptCom",
  props: {
    // 弹出位置
    placement: {
      type: String,
      default: "top",
    },
    width: {
      type: [String, Number],
      default: 200,
    },
    // 触发方式：hover / click / focus
    trigger: {
      type: String,
      default: "hover",
    },
    // 弹窗自定义类名
    popperClass: {
      type: String,
      default: "",
    },
    iconleft: {
      type: String,
      default: '3px',
    },
    isWhite: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style scoped lang="scss">
.prompt-content {
  line-height: 1.6;
  color: #606266;
}
.icon_box{
  cursor: pointer;
}
</style>
